export default "__VITE_ASSET__0ba3d8ea__"